import { useTranslation } from 'react-i18next';
import { KIOSK__SELECTION_ERROR } from 'translations/constants';
import { KioskErrorText, KioskErrorWrap } from '../styles';

/** Shown on any non-401 feed failure. The feed is cleared by the hook, so no stale data renders. */
const KioskErrorState = () => {
  const [t] = useTranslation();
  return (
    <KioskErrorWrap>
      <KioskErrorText>{t(KIOSK__SELECTION_ERROR)}</KioskErrorText>
    </KioskErrorWrap>
  );
};

export default KioskErrorState;
